import React, { useState } from 'react';
import BadgeHeroSection from '../components/HeroSectionBadge';
import ProductInfo from '../components/ProductInfo';
import NewsCarousel from '../components/NewsCarousel';
import Benefits from '../components/Benefits';
import AudienceNavigation from '../components/AudienceNavigation';
import BottomPostcodeSection from '../components/BottomPostCodeSection';
import { graphql, Link } from 'gatsby';
import PostcodeSearch from '../components/PostcodeSearch';
import LitImage from '../components/images/LitImage';
import GetSEOData from '../data/SEO';
import SEO from '../components/SEO';
import LitStructuredText from '../components/generic/LitStructuredText';
import AnyQuestions from '../components/AnyQuestions';
const audienceTemplate = ({ data }) => {
  const audienceData = data.datoCmsAudienceLandingPagesModel;
  const audienceDataBenefits = data.datoCmsAudienceLandingPagesModel.benefits;
  const navigationCheckArea = data.navigationArea;
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [inputDisplayValue, setInputDisplayValue] = useState('');

  let { title, description } = GetSEOData(`audience`);
  return (
    <div className="bootstrap">
      <SEO
        title={audienceData.seoTitle ?? title}
        description={audienceData.seoDescription ?? description}
        metaTags={audienceData.seo}
      />
      <div className="audience-container">
        <BadgeHeroSection
          heading={audienceData.heroHeading}
          subHeading={audienceData.heroSubheading}
          heroImageDesktop={audienceData.heroImage}
          heroImageMobile={audienceData.heroImage}
          secondaryHeroImage={audienceData.heroImage}
          mode={audienceData.heroDarkMode}
          audiencePage={audienceData.slug}
          layout={audienceData.layout}
          heroInnerNoPadding={audienceData.slug === 'gaming'}
        />
        <div className="navigation-container">
          {audienceDataBenefits?.map(
            ({ quicknavHeading, quicknavBody, quicknavImage, id }, index) => {
              return (
                <AudienceNavigation
                  heading={quicknavHeading}
                  body={quicknavBody}
                  image={quicknavImage}
                  path={id}
                  index={index}
                />
              );
            },
          )}
          <div className="link-container">
            <div className="navigation-icon">
              <LitImage image={navigationCheckArea} alt="blue icon" />
            </div>
            <div className="navigation-header">
              <h2>Check your area</h2>
            </div>
            <div className="navigation-content">
              <p>Check if you can get that Lit feeling</p>
            </div>
            <div className="navigation-go-section">
              <Link to="#bottomPostcode" className="navigation-link">
                Find out more
              </Link>
            </div>
          </div>
        </div>
        <div
          className={`audience-section-one ${
            audienceData.introDarkMode ? 'BlackMode' : 'YellowMode'
          }`}
        >
          <div className="audience-section-one-container">
            <h3 className="audience-section-one-heading">
              <LitStructuredText data={audienceData.introHeading} basic />
            </h3>
            <p className="audience-section-one-content">
              <LitStructuredText data={audienceData.introBody} basic />
            </p>
            <div className="PostcodeSearchPrimary">
              <PostcodeSearch
                placeholder="Check availability"
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                inputDisplayValue={inputDisplayValue}
                setInputDisplayValue={setInputDisplayValue}
              />
            </div>
          </div>
        </div>
        <div className="benefits-container">
          {audienceData.slug === 'gaming' && (
            <div className="benefits-header">
              <LitStructuredText data={audienceData.bodyTitle} basic />
            </div>
          )}
          {audienceDataBenefits?.map(
            (
              {
                heading,
                backgroundColour,
                body,
                featureImage,
                id,
                backgroundImage,
                backgroundImageMobile,
              },
              index,
            ) => {
              return (
                <Benefits
                  heading={heading}
                  backgroundColor={backgroundColour}
                  body={body}
                  featureImage={featureImage}
                  index={index}
                  id={id}
                  slug={audienceData.slug}
                  backgroundImage={backgroundImage}
                  backgroundImageMobile={backgroundImageMobile}
                />
              );
            },
          )}
        </div>
        <BottomPostcodeSection
          heading="Check if you can get that Lit feeling:"
          backgroundColor="Yellow"
        />
        <NewsCarousel />
        <AnyQuestions />
      </div>
    </div>
  );
};
export default audienceTemplate;
export const query = graphql`
  query ($id: String!) {
    datoCmsAudienceLandingPagesModel(id: { eq: $id }) {
      seo {
        description
        title
        twitterCard
        image {
          gatsbyImageData
        }
      }
      slug
      seoTitle
      seoDescription
      layout
      customProductHeading {
        value
      }
      heroDarkMode
      heroHeading {
        value
      }
      heroImage {
        gatsbyImageData
      }
      heroSubheading {
        value
      }

      introDarkMode
      introHeading {
        value
      }
      introBody {
        value
      }
      bodyTitle {
        value
      }
      benefits {
        backgroundImage {
          gatsbyImageData
        }
        backgroundImageMobile {
          gatsbyImageData
        }
        heading {
          value
        }
        id
        backgroundColour
        body {
          value
        }
        featureImage {
          gatsbyImageData
        }
        quicknavImage {
          gatsbyImageData
        }
        quicknavBody {
          value
        }
        quicknavHeading {
          value
        }
      }
    }
    navigationArea: file(
      relativePath: { eq: "audience-images/audienceNavigationArrow.png" }
    ) {
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`;
